var map = {
	"./6sicuro-logo.png": 244,
	"./appquality-logo.png": 245,
	"./arg-logo.png": 246,
	"./assaperlo-logo.png": 247,
	"./d4f-logo.png": 248,
	"./datafolio-logo.png": 135,
	"./datafolio4friends-logo.png": 249,
	"./easypanel-logo.png": 250,
	"./finital-logo.png": 251,
	"./giuriolo-logo.png": 252,
	"./internaltesting-logo.png": 253,
	"./mistore-logo.png": 145,
	"./romandini-logo.png": 254
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 144;